import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "TimeTrackingModule"
const debug = false

export class TimeTrackingModule extends ModuleProto {

    public isBillableTimeEnabled        : boolean   // indicates if we need billable/not-billable field
    public defaultIsBillable            : boolean   // company level setting for default time report

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.TIME_TRACKING, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Time tracking"
        this.description                = "The Time Tracking module enables users to accurately track and manage their time spent on tasks and projects. With customizable settings and reporting options, the Time Tracking module streamlines time management processes and provides valuable insights into project progress and resource allocation."
        this.svgIcon                    = "isvg-view-my-time"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Time and Resources"
        this.settingsUrl                = "settings/time-tracking"
        this.parentSection              = SettingsParentSection.TIME

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.feature                    = Feature.TIME_TRACKING

        this.isBillableTimeEnabled      = _.get(moduleConfig,'isBillableTimeEnabled', false) as boolean
        this.defaultIsBillable          = _.get(moduleConfig,'defaultIsBillable', true) as boolean

        this.validateFeature()

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        if (this.isBillableTimeEnabled) {
            result['isBillableTimeEnabled'] = true
        }

        if (!this.defaultIsBillable) {
            result['defaultIsBillable'] = false
        }

        return result
    }

}